export enum DocumentTypes {
  ECHEANCIER = 350,
}
